import React from 'react';
import { SearchGameItem } from '../SearchGameItem';

export const SearchGamesListItem = ({
    data,
    index,
    style,
}) => {
    const game = data[index];

    return (
        <div
            key={game.id}
            style={style}
        >
            <SearchGameItem
                game={game}
            />
        </div>
    );
};
